import React, { useEffect } from "react";

import { fireTrack } from "@swa-ui/analytics";
import { Link, Section } from "@swa-ui/core";
import { ErrorMessage } from "@swa-ui/inflight";
import i18n from "@swa-ui/locale";

import styles from "./ErrorPage.module.scss";

const BROWSE_LINK_HREF = "https://www.southwest.com/?clk=WFSL_CONNERR_BRWS";

export const ErrorPage = () => {
  useEffect(() => {
    fireTrack("squid", { page_description: "inflight-error-page" });
  }, []);

  return (
    <Section {...getProps()}>
      <ErrorMessage
        className={styles.errorMessage}
        body={
          <>
            {i18n("ErrorPage__BODY_PART1")}
            <Link className={styles.link} href={BROWSE_LINK_HREF} isExternal>
              {i18n("ErrorPage__BODY_PART2")}
            </Link>
            {i18n("ErrorPage__BODY_PART3")}
          </>
        }
        heading={i18n("ErrorPage__HEADING")}
        iconName="Advisory"
      />
    </Section>
  );

  function getProps() {
    return {
      grid: true,
      role: "main",
      sectionClassName: styles.layout,
    };
  }
};
